class WCData {
    constructor() {
        this.baseURL = process.env.REACT_APP_WC_SITE_URL;
        this.consumerKey = process.env.REACT_APP_WC_CK;
        this.consumerSecret = process.env.REACT_APP_WC_CS;
        this.inProgress = false;
    }

    async getFontsData() {
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/fonts_data`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        return await response.json();
    }
}

export default WCData;